const admin = window.$admin || false;
function location(location, landmark = false) {
    let place = location.user.place;
    let city = location.user.city;
    let profile = location.user.profile
    if (city && place && city != place) {
        return city + ' - ' + place + (landmark && profile && city != profile && place != profile ? '<br><small>' + profile + '</small>' : '');
    } else if (city) {
        return city + (landmark && profile && city != profile? '<br><small>' + profile + '</small>' : '');
    }
    return '-'
}


export default {location,admin}
